import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { interval, Subject, takeUntil } from 'rxjs';
import axios from 'src/app/Service/axios';

@Component({
  selector: 'app-vcu',
  templateUrl: './vcu.component.html',
  styleUrls: ['./vcu.component.css']
})

export class VcuComponent implements OnInit {
  overviewData;
  speed = 0;
  rpm = 0;
  motorProgress = '0%';
  fuelProgress = '0%';

  dashboardStats = [
    {
      label: 'سطح سوخت',
      keyValue: 'FuelLevel',
      prefix: '%'
    },
    {
      label: 'سوخت مصرف شده',
      keyValue: 'OEMTotalFuelConsumed',
      prefix: ''
    },
    {
      label: 'مدت زمان روشن',
      keyValue: 'DurationofSwitchON',
      prefix: ''
    },
    {
      label: 'دمای هوای محیط',
      keyValue: 'AmbientTemp',
      prefix: '°C'
    }
  ]
  engineStats = [
    {
      label: 'فشار مطلق مانیفولد هوا(kpa)',
      keyValue: 'ManifoldAbsolutePressure',
      prefix: ''
    },
    {
      label: 'دمای هوای ورودی',
      keyValue: 'IntakeAirTemperature',
      prefix: '°C'
    },
    {
      label: 'فشار بارومتریک محیط(kpa)',
      keyValue: 'BarometricPressure',
      prefix: ''
    },
    {
      label: 'دمای مایع خنک‌کننده موتور',
      keyValue: 'CoolantTemperature',
      prefix: '°C'
    },
    {
      label: 'زمان روشن بودن موتور',
      keyValue: 'EngineRunTime',
      prefix: ''
    },
    {
      label: 'نرخ جریان هوا(g/s)',
      keyValue: 'MassAirFlow',
      prefix: ''
    },
    {
      label: 'فشار ریل سوخت(kpa)',
      keyValue: 'FuelRailPressure',
      prefix: ''
    },
    {
      label: 'فشار ریل سوخت نسبت به خلاء(kpa)',
      keyValue: 'FuelRailPressure2ManifoldVacuum',
      prefix: ''
    },
    {
      label: 'ولتاژ سنسور اکسیژن اول',
      keyValue: 'Sensor1VoltageO',
      prefix: '°C'
    },
    {
      label: 'ولتاژ سنسور اکسیژن دوم',
      keyValue: 'Sensor2VoltageO',
      prefix: '°C'
    },
    {
      label: 'اصلاح سوخت سنسور اول',
      keyValue: 'Sensor1TrimO',
      prefix: ''
    }
  ]

  mdl_Search: FormGroup = this.formBuilder.group({
    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),
    strSession: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('Session')!)),
    strUnitID: new FormControl(),
  });

  private destroy$ = new Subject<void>();

  @ViewChild('speedNeedle') speedNeedle: ElementRef<HTMLElement>;
  @ViewChild('rpmNeedle') rpmNeedle: ElementRef<HTMLElement>;

  constructor(
    private el: ElementRef,
    private _tooltip: NotificationService,
    private router: Router,
    public _otherService: OtherService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private gurdService: GurdServiceService,
  ) {

  }

  ngOnInit(): void {
    this.mdl_Search.patchValue({
      strUnitID: this.route.parent?.parent?.snapshot?.params['id'] ?? '',
    });

    this.fetchOverview();

    interval(15000).pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.fetchOverview(false);
    })
  }

  ngOnDestroy() {
    this.stopTimer();
  }

  stopTimer() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async fetchOverview(showSpinner: boolean = true) {

    if (showSpinner) {
      this._otherService.Showspinner();
    }

    let res = JSON.parse((await axios.post(`OBD2_LastValues`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1xxA4' } });

      return;

    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.overviewData = this.transformData(res);

    this.speed = this.overviewData?.VehcleSpeed ?? 0;
    this.setSpeed(this.speed);

    this.rpm = this.overviewData?.EngineRPM ?? 0;
    this.setRpm(this.rpm);

    this.motorProgress = (this.overviewData?.EngineLoad ?? 0) + '%';
    this.fuelProgress = (this.overviewData?.AbsoluteLoadValue ?? 0) + '%';

  }

  transformData(data: any[]): object {
    const transformedObject = data.reduce((acc, item) => {
      const key = item.strEnglishName.trim();
      acc[key] = item.strValue;
      return acc;
    }, {} as { [key: string]: string });
    return transformedObject;
  }

  setSpeed(speed: number) {
    const minAngle = -63;
    const maxAngle = 163;
    const maxSpeed = 180;

    const angle = minAngle + (speed / maxSpeed) * (maxAngle - minAngle);
    this.speedNeedle.nativeElement.style.transform = `rotate(${angle}deg)`;
  }

  setRpm(rpm: number) {
    const minAngle = -71;
    const maxAngle = 171;
    const maxRpm = 8000;

    const angle = minAngle + (rpm / maxRpm) * (maxAngle - minAngle);
    this.rpmNeedle.nativeElement.style.transform = `rotate(${angle}deg)`;
  }

  getBadgeClass(state: number | boolean): string {

    if (typeof (state) == 'number' && state > 1) {
      return 'app-badge app-badge-success';
    }

    if (typeof (state) == 'string') {
      return 'app-badge app-badge-state';
    }

    switch (state) {
      case 0:
        return 'app-badge app-badge-error';
      case false:
        return 'app-badge app-badge-error';
      case 1:
        return 'app-badge app-badge-success';
      case true:
        return 'app-badge app-badge-success';
      case -1:
        return 'app-badge app-badge-state';
      default:
        return 'app-badge';
    }

  }

  getBoardClass(state: number | boolean): string {

    if (typeof (state) == 'number' && state < 0) {
      return '-icon';
    }

    switch (state) {
      case 0:
        return '-icon';
      case false:
        return '-icon';
      case 1:
        return '-icon active';
      case true:
        return '-icon active';
      case -1:
        return '-icon';
      case -100:
        return '-icon';
      default:
        return '-icon active';
    }

  }

}
